var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { staticClass: "root", attrs: { xs: "3" } },
    [
      _c(
        "w-container",
        { style: { overflowX: "hidden" } },
        [
          _c(
            "w-modal",
            {
              model: {
                value: _vm.missingModule,
                callback: function ($$v) {
                  _vm.missingModule = $$v
                },
                expression: "missingModule",
              },
            },
            [
              _c("app-missing-module-modal", {
                attrs: { "module-id": 13 },
                on: {
                  close: function ($event) {
                    _vm.missingModule = false
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-list",
            { staticClass: "w-card" },
            [
              _c(
                "w-list-item",
                {
                  class: { active: _vm.value == 12 },
                  on: {
                    click: function ($event) {
                      return _vm.clicked(12)
                    },
                  },
                },
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("pdf-preview"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            {
              staticClass: "mt",
              style: { height: "auto" },
              attrs: { tag: "w-card" },
            },
            [
              _c(
                "w-list",
                [
                  _c(
                    "w-list-item",
                    {
                      class: { active: _vm.value == null },
                      on: {
                        click: function ($event) {
                          return _vm.clicked(null)
                        },
                      },
                    },
                    [
                      _c("w-list-item-text", [
                        _vm._v(_vm._s(_vm.$ct("example"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._l(_vm.tabs, function (tab) {
                    return _c(
                      "w-list-item",
                      {
                        key: tab[0],
                        class: { active: _vm.value == tab[0] },
                        on: {
                          click: function ($event) {
                            return _vm.clicked(tab[0])
                          },
                        },
                      },
                      [_c("w-list-item-text", [_vm._v(_vm._s(tab[1]))])],
                      1
                    )
                  }),
                ],
                2
              ),
              _c("w-spacer"),
            ],
            1
          ),
          !_vm.fullControl && _vm.showAdvancedSettings
            ? _c(
                "w-button",
                {
                  staticClass: "flat mt",
                  attrs: { icon: "lock" },
                  on: {
                    click: function ($event) {
                      _vm.missingModule = true
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("advanced-settings")) + " ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }